import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { getFormCate, getMyApplyDetailsById, editMyApplyDetailsById, startProcess, deletFormFillById, queryMyBelowApplyList } from '@/services/myApply';
import selectPerson from '@/components/select-person/genera';
import { nextFlowNode, complete, saveFlowTrack, queryFormFillById } from '@/services/form';
var columns = [{
  title: '申请流水号',
  dataIndex: 'id',
  align: 'center',
  scopedSlots: {
    customRender: 'needId'
  },
  width: 50
}, {
  title: '标题',
  dataIndex: 'formName',
  scopedSlots: {
    customRender: 'formName'
  },
  width: 300
}, {
  title: '',
  dataIndex: '',
  width: 15,
  scopedSlots: {
    customRender: 'formNameTmp'
  }
}, {
  title: '表单类型',
  dataIndex: 'cateId',
  width: 50,
  scopedSlots: {
    customRender: 'cateType'
  }
}, {
  title: '申请时间',
  width: 100,
  dataIndex: 'createTime'
}, {
  title: '办理状态',
  dataIndex: 'fillStatus',
  width: 50,
  scopedSlots: {
    customRender: 'statusType'
  }
}, {
  title: '概述',
  dataIndex: 'summary',
  width: 100
}, {
  title: '操作',
  width: 50,
  scopedSlots: {
    customRender: 'operation'
  }
}];
var dataSource = [];
export default {
  name: 'myApplyMgr',
  components: {
    selectPerson: selectPerson
  },
  data: function data() {
    var _ref;
    var usersTabList = [{
      title: '组织',
      value: 0
    }, {
      title: '组织成员',
      value: 1
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }, {
      title: '岗位成员',
      value: 5
    }];
    var userGroupTabList = [{
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }];
    return _ref = {
      form1: {},
      userGroupTabList: userGroupTabList,
      userGroupObj: {},
      flowApproverSetList: [],
      visible: false,
      visibleId: '',
      loading: false,
      expand: false,
      usersList: {},
      usersTabList: usersTabList,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      timeValue: undefined,
      form: {
        formName: undefined,
        cateId: undefined,
        fillStatus: undefined,
        currentNo: 1,
        pageSize: 10,
        startDateTime: '',
        endDateTime: '',
        timeValue: undefined,
        summary: '',
        fillId: '',
        content: ''
      },
      fillStautsList: [{
        itemName: '草　稿',
        itemKey: 0
      }, {
        itemName: '待审批',
        itemKey: 1
      }, {
        itemName: '审批中',
        itemKey: 2
      }, {
        itemName: '通　过',
        itemKey: 3
      }, {
        itemName: '驳　回',
        itemKey: 4
      }, {
        itemName: '作　废',
        itemKey: 5
      }, {
        itemName: '不通过',
        itemKey: 6
      }, {
        itemName: '挂　起',
        itemKey: 7
      }],
      fillStautsColorList: [{
        itemName: '#bfbfbf',
        itemKey: 0
      }, {
        itemName: 'rgb(24, 144, 255)',
        itemKey: 1
      }, {
        itemName: '#1890ff',
        itemKey: 2
      }, {
        itemName: 'rgb(79, 191, 73)',
        itemKey: 3
      }, {
        itemName: '#ff9806',
        itemKey: 4
      }, {
        itemName: '#d6dce5',
        itemKey: 5
      }, {
        itemName: 'rgb(220, 33, 39)',
        itemKey: 6
      }],
      columns: columns,
      total: 0,
      dataSource: dataSource,
      selectedRows: [],
      cateList: [{
        cateId: 1,
        cateMemo: '',
        cateName: '行政',
        parentId: 0,
        sortNum: 1,
        status: 1,
        treeLevel: 0
      }]
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "visible", false), "confirmLoading", false), "pagination", this.$hdk.page()), "viewVisible", false), "formData", {
      list: [],
      config: {
        labelWidth: 100,
        labelPosition: 'right',
        size: 'small',
        customClass: '',
        ui: 'element',
        layout: 'horizontal',
        labelCol: 3,
        width: '100%',
        hideLabel: false,
        hideErrorMessage: false
      }
    }), "viewData", {
      input: 'input',
      text: 'text',
      radio: 'Option 1'
    }), "editData", {
      input: 'input',
      text: 'text',
      radio: 'Option 1'
    }), "editVisible", false), "editItem", {}), "auditUserVisible", false), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "nextAuditUser", ''), "nextAuditUsers", []), "nextAuditUserFlag", false), "nextAuditUserType", ''), "nextAuditGroup", ''), "procInsId", ''), "formObject", {
      organPostId: []
    }), "options", []), "userInfo", this.$hdk.userInfo.get()), "rules", {
      organPostId: [{
        required: true,
        message: '请选择所属组织及岗位'
      }]
    });
  },
  methods: {
    //表格行点击事件
    rowClick: function rowClick(record, index) {
      var _this = this;
      return {
        on: {
          dblclick: function dblclick() {
            if (record.fillStatus == 0 || record.fillStatus == 4) {
              _this.$router.push({
                path: '/formReview/reviewCenter/processMain',
                query: {
                  item: JSON.stringify(record),
                  type: record.fillStatus == 4 ? 4 : 1 //4:被驳回, 1:正常草稿(已启动流程和未启动流程)
                }
              });
            } else {
              _this.$router.push({
                path: '/formReview/reviewCenter/viewProcess',
                query: {
                  procInsId: record.processInstanceId,
                  fillId: record.id,
                  fillStatus: record.fillStatus
                }
              });
            }
          }
        }
      };
    },
    dbTwoClick: function dbTwoClick(row) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: row.processInstanceId,
          fillId: row.id,
          fillStatus: row.fillStatus
        }
      });
    },
    handleVisibleChange: function handleVisibleChange(row) {
      // if (row.trackStatus == 2) {
      //     this.visible = true;
      // }
    },
    handlepopConfirmConfirm: function handlepopConfirmConfirm(row) {
      var _this2 = this;
      saveFlowTrack(row).then(function (res) {
        _this2.visible = false;
        _this2.onQueryMyApplyList();
      });
    },
    handlepopConfirmCancel: function handlepopConfirmCancel() {
      this.visible = false;
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value) {
      var $set = this.$set,
        formObject = this.formObject;
      // 组织岗位赋值
      $set(formObject, 'organId', value[0]);
      $set(formObject, 'postId', value[1]);
      this.formObject.customize = {};
      this.formObject.customize.organId = value[0];
      this.formObject.customize.postId = value[1];
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    toSave: function toSave(row) {
      var _this3 = this;
      this.visible = false;
      this.visibleId = row.processInstanceId;
      if (row.trackStatus == 2) {
        this.visible = true;
      } else {
        this.visible = false;
        saveFlowTrack(row).then(function (res) {
          _this3.onQueryMyApplyList();
        });
      }
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    initDict: function initDict() {
      var that = this;
      getFormCate().then(function (res) {
        var list = res.data.data;
        that.cateList = list;
      });
    },
    queryTableList: function queryTableList() {
      sessionStorage.setItem('searchForm', JSON.stringify(this.form));
      this.form.currentNo = 1;
      this.pagination.current = 1;
      this.onQueryMyApplyList();
      sessionStorage.removeItem('Pagination_MeManagementApplication');
    },
    restForm: function restForm() {
      var $refs = this.$refs;
      sessionStorage.removeItem('searchForm');
      $refs.searchFrom.resetFields();
    },
    onQueryMyApplyList: function onQueryMyApplyList() {
      var _this4 = this;
      var pagination = this.pagination,
        form = this.form,
        pager = _.assign({}, pagination);
      this.loading = true;
      var searchForm = JSON.parse(sessionStorage.getItem('searchForm'));
      if (searchForm) {
        this.form = searchForm;
      }
      if (this.form.timeValue) {
        this.form.startDateTime = this.form.timeValue[0];
        this.form.endDateTime = this.form.timeValue[1];
      }
      this.form.currentNo = pager.current;
      this.form.pageSize = pager.pageSize;
      queryMyBelowApplyList(this.form).then(function (res) {
        var _res$data = res.data,
          code = _res$data.code,
          data = _res$data.data;
        if (code == 200) {
          _this4.dataSource = data && Object.prototype.hasOwnProperty.call(data, 'rows') ? data.rows : [];
          _this4.total = data && Object.prototype.hasOwnProperty.call(data, 'total') ? data.total : 0;
          _.assign(pagination, {
            total: _this4.total,
            current: pager.current,
            pageSize: pager.pageSize
          });
          _.assign(form, pager.form);
        }
      }).finally(function () {
        _this4.loading = false;
      });
    },
    onClickEdit: function onClickEdit(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/processMain',
        query: {
          item: JSON.stringify(record),
          type: record.fillStatus == 4 ? 4 : 1 //4:被驳回, 1:正常草稿(已启动流程和未启动流程)
        }
      });
      // console.log(JSON.stringify(record));
      // this.editItem = record;
      // this.usersList = {
      //     postData: [],
      //     organData: [],
      //     userData: []
      // };
      // getMyApplyDetailsById(record).then(res => {
      //     if (res.data.code === 200) {
      //         console.log('res', res.data.data);
      //         this.formData = JSON.parse(res.data.data.formData);
      //         this.editData = JSON.parse(res.data.data.fillData);
      //         this.editVisible = true;
      //         this.formObject.organPostId[0] = res.data.data.organId;
      //         this.formObject.organPostId[1] = res.data.data.postId;
      //         this.$nextTick(() => {
      //             console.log(this.formData, this.editData, '===================>formData1');
      //             this.$refs.editGenerateForm.refresh();
      //         });
      //     }
      // });
    },
    onClickPublish_back: function onClickPublish_back(text, record) {
      var _this5 = this;
      startProcess(text).then(function (res) {
        if (res.data.code === 200) {
          _this5.onQueryMyApplyList();
          _this5.$message.success('提交成功');
        }
      });
    },
    deleteInfo: function deleteInfo(text, record) {
      var _this6 = this;
      var $confirm = this.$confirm,
        $message = this.$message;
      $confirm("确认删除吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        deletFormFillById({
          id: record.id
        }).then(function (res) {
          if (res.data.code == 200) {
            $message.success('删除成功');
          }
        });
        _this6.onQueryMyApplyList();
      }).catch(function () {});
    },
    onClickPublishThen: function onClickPublishThen(procInsId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, param;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this7.procInsId = procInsId;
              _context.n = 1;
              return nextFlowNode({
                procInsId: _this7.procInsId
              });
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                param = {
                  procInsId: _this7.procInsId,
                  nextNodeCliamUserId: '',
                  nextNodeUserType: '',
                  comment: '发起流程申请',
                  processStatus: 1
                };
                if (res.data.data == undefined) {
                  _this7.completeTask(param);
                } else if (Object.keys(res.data.data).length > 0) {
                  if (res.data.message == '自由选择') {
                    _this7.auditUserVisible = true;
                    _this7.flowApproverSetList = res.data.data;
                  } else {
                    _this7.completeTask(param);
                  }
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    onClickPublish: function onClickPublish(text) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              queryFormFillById({
                id: text.id
              }).then(function (res) {
                //查询流程是否启动
                var formFill = res.data.data;
                if (formFill != null && formFill.processInstanceId != null) {
                  //如果已经启动流程(还是草稿状态),则需要设置自由选择审批人

                  _this8.onClickPublishThen(formFill.processInstanceId);
                } else {
                  startProcess(_defineProperty(_defineProperty({
                    formName: text.formName,
                    fillId: text.fillId,
                    versionId: text.versionId,
                    fillData: text.fillData.value
                  }, "fillId", text.id), "formId", text.formId)).then(function (res) {
                    if (res.data.code == 200) {
                      // this.$message.success('提交成功')
                      _this8.onClickPublishThen(res.data.data);
                    }
                  });
                }
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    onMyApplyView: function onMyApplyView(record) {
      var _this9 = this;
      getMyApplyDetailsById(record).then(function (res) {
        if (res.data.code === 200) {
          _this9.formData = JSON.parse(res.data.data.formData);
          _this9.viewData = JSON.parse(res.data.data.fillData);
          _this9.viewVisible = true;
          _this9.$nextTick(function () {
            _this9.$refs.generateForm.refresh();
          });
        }
      });
    },
    onChange: function onChange(value, dateString) {},
    /*
     * 表格改变事件
     */
    onChangeTable: function onChangeTable(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      sessionStorage.setItem('Pagination_MeManagementApplication', JSON.stringify(this.pagination));
      this.onQueryMyApplyList();
    },
    onOk: function onOk(value) {},
    onViewClose: function onViewClose() {
      this.viewVisible = false;
    },
    onEditClose: function onEditClose() {
      this.editVisible = false;
    },
    handleSubmit: function handleSubmit() {
      var _this0 = this;
      var copyManData = new Array();
      this.$refs.editGenerateForm.getData().then(function (data) {
        editMyApplyDetailsById({
          id: _this0.editItem.id,
          fillData: data,
          fillId: _this0.editItem.fillId,
          versionId: _this0.editItem.versionId,
          copyManData: copyManData,
          organId: _this0.formObject.organPostId[0],
          postId: _this0.formObject.organPostId[1]
        }).then(function (res) {
          if (res.data.code == 200) {
            _this0.$message.success('保存成功');
            _this0.onEditClose();
          } else {
            _this0.$message.error(res.data.message);
          }
        });
      }).catch(function (e) {});
    },
    handleOk: function handleOk(e) {
      var _this1 = this;
      this.nextAuditUserFlag = true;
      this.flowApproverSetList.map(function (item) {
        var node = _this1.userGroupObj[item.taskDefKey];
        if (!node || JSON.stringify(node) == '{}' || node.postData.length == 0 && node.userData.length == 0) {
          _this1.$message.info('请选择节点: "' + item.taskName + '" 的审核人');
          _this1.nextAuditUserFlag = false;
        }
      });
      if (!this.nextAuditUserFlag) {
        return;
      }
      var param = {
        procInsId: this.procInsId,
        approverSetMap: this.userGroupObj,
        comment: '发起流程申请',
        processStatus: 1 //待审批
      };
      this.completeTask(param);
    },
    handleCancel: function handleCancel(e) {
      this.auditUserVisible = false;
    },
    handleNextAuditUserChange: function handleNextAuditUserChange(index) {
      this.nextAuditUser = this.nextAuditUsers[index].userId;
      this.nextAuditGroup = this.nextAuditUsers[index].levelRoleId;
    },
    completeTask: function completeTask(param) {
      var _this10 = this;
      complete(param).then(function (res) {
        if (res.data.code == 200) {
          _this10.$message.success('提交成功');
          _this10.auditUserVisible = false;
          _this10.onQueryMyApplyList();
          // this.$router.push({
          //     path: '/formReview/reviewCenter/viewProcess',
          //     query: { procInsId: this.procInsId }
          // })
        }
      });
    },
    loadData: function loadData() {
      this.onQueryMyApplyList();
    },
    restQuery: function restQuery() {
      this.form = {
        formName: '',
        cateId: '',
        fillStatus: '',
        currentNo: 1,
        pageSize: 10,
        startDateTime: '',
        endDateTime: ''
      };
      this.timeValue = undefined;
      this.loadData();
    },
    onViewWaitMeApply: function onViewWaitMeApply(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.processInstanceId,
          fillId: record.id,
          fillStatus: record.fillStatus
        }
      });
    }
  },
  mounted: function mounted() {
    this.initDict();
    var savedPagination = sessionStorage.getItem('Pagination_MeManagementApplication');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.loadData();
  },
  created: function created() {
    var userInfo = this.userInfo;
    // 级联数据处理
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
  }
};